module.exports = __webpack_public_path__ + "img/Fort_Worth_Badge.184ac46f.png";